// extracted by mini-css-extract-plugin
export default {"icon-size":"24","container":"select-item_container__DIxNz","button":"select-item_button__qcnAV"};